/**
 * @date: 1/17/21
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2021 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import {Button, Container, alpha} from "@mui/material";
import Alert from '@mui/material/Alert';
import ShowMessage from "../utils/show-message";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import ShowInfo from "./ShowInfo";


export default function InfoPage(props){
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState({});
    const {title} = props;
    const queryParam = getQueryParams();

    return (
        <div>
            <Container className='auth-container' maxWidth='xs' >
                <div className='logo-wrapper'>
                    <img src={require('../images/dt-logo.png')?.default}/>
                </div>
                {/*<br/>*/}
                {/*<img src={require('../images/dt-logo.png')}/>*/}
                {/*<br/><br/>*/}
                {/*<h3 className='auth-title'>{title}</h3>*/}
                {/*<ShowMessage msg={msg} />*/}

                {/*{queryParam && queryParam.msg  && <Alert color='info' icon={false} className={classes.message} >*/}
                {/*    {queryParam.msg}*/}
                {/*</Alert>}*/}

                <Router basename="/info">
                    <Routes>
                        {/*react router ver 5.3.0*/}
                        {/*<Route path="/ActivationFailed" render={(props) => <ShowInfo title='Activation Failed' {...props} />}/>*/}
                        {/*<Route path="/WorkflowExpired" render={(props) => <ShowInfo title='Workflow Expired' {...props} />}/>*/}

                        {/* react router ver 6 */}
                        <Route path="/ActivationFailed" element={<ShowInfo title='Activation Failed' />}/>
                        <Route path="/WorkflowExpired" element={<ShowInfo title='Workflow Expired' />}/>
                    </Routes>
                </Router>

                {/*<div>*/}
                {/*    <Button onClick={() => handleTransfer(true)} color='primary' variant='contained' className={classes.button} > Join {invitationOrganization.name} </Button>*/}
                {/*    <Button onClick={() => handleTransfer(false)} color='primary' variant='outlined' className={classes.button} > Stay in {organization.name} </Button>*/}
                {/*</div>*/}


            </Container>

        </div>

    );
}
